import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class SortingRequestResource {
    @JsonProperty("field")
    fieldName: string;

    @JsonProperty("asc")
    ascending: boolean = false;

    constructor(init?: Partial<SortingRequestResource>) {
        Object.assign(this, init);
    }
}
